import React, { Component } from 'react';
import { get } from 'lodash';
import PropTypes from 'prop-types';

import ReportOverviewCard from '../ReportOverviewCard';
import noop from '../../utils/noop';

import { getMonthNameWithPrefix } from '../../utils/dateUtility';
import stripHTML from '../../utils/stripHTML';

import {
  ENTERPRISE_CONNECTIONS_DESCRIPTION,
  DETAILED_REPORT_TYPES as T
} from '../../utils/resources/reports';

class QuotaSummaryEnterpriseUsersConsumption extends Component {
  hasEnterpriseConnectionsQuota() {
    const { enterpriseConnectionsReportData } = this.props;

    return get(enterpriseConnectionsReportData, 'quota.connections') > 0;
  }

  render() {
    const {
      enterpriseConnectionsReportData,
      showReportDetails,
    } = this.props;

    const { month } = enterpriseConnectionsReportData;

    return (
      <ReportOverviewCard
        {...this.props}
        title="Enterprise Connections"
        subtitle={getMonthNameWithPrefix(month)}
        description={stripHTML(ENTERPRISE_CONNECTIONS_DESCRIPTION)}
        descriptionForMixedPlan={stripHTML(
          ENTERPRISE_CONNECTIONS_DESCRIPTION
        )}
        charts={[
          {
            type: 'quotaEnterpriseConnections',
            quota: get(enterpriseConnectionsReportData, 'quota.connections'),
            currentQuota: get(enterpriseConnectionsReportData, 'total.connections.enterprise', 0),
            percentage: get(enterpriseConnectionsReportData, 'percentage.connections')
          }
        ]}
        handleClick={showReportDetails(T.ENTERPRISE_CONNECTIONS_USERS)}
      />
    );
  }
}

QuotaSummaryEnterpriseUsersConsumption.propTypes = {
  showReportDetails: PropTypes.func,
  enterpriseConnectionsReportData: PropTypes.object,
};

QuotaSummaryEnterpriseUsersConsumption.defaultProps = {
  showReportDetails: noop,
  enterpriseConnectionsReportData: {},
};

export default QuotaSummaryEnterpriseUsersConsumption;
